// extracted by mini-css-extract-plugin
module.exports = {"emailTabMinimized":"az_DKb","emailTabMinimizedContent":"az_EKb","promoToggle":"az_FKb","promoText":"az_GKb","chevronIcon":"az_HKb","rotateToggle":"az_IKb"};